import { useCallback, useState } from 'react';

import applyImageFileToCanvas from '../utils/applyImageFileToCanvas';
import useStore from './useStore';

const useUploadImageAnnotation = () => {
  const store = useStore();
  const [isUploading, setIsUploading] = useState(false);

  const uploadImagesFromFiles = useCallback(
    async (fileList) => {
      const files = Array.from(fileList || []).filter((file) =>
        file.type?.startsWith('image/'),
      );
      if (files.length === 0) {
        return;
      }

      setIsUploading(true);
      try {
        for (const file of files) {
          // eslint-disable-next-line no-await-in-loop -- one undo step per image
          await applyImageFileToCanvas({
            file,
            dispatch: store.dispatch,
            annotations: store.annotations,
            selectionsIds: store.selectionsIds,
            shownImageDimensions: store.shownImageDimensions,
            adjustments: store.adjustments,
          });
        }
      } finally {
        setIsUploading(false);
      }
    },
    [store],
  );

  return { uploadImagesFromFiles, isUploading };
};

export default useUploadImageAnnotation;
